import React, { useEffect, useState } from "react";
import { HorizontalBar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import Title from "../../../components/title.js";
import "react-data-table-component-extensions/dist/index.css";
import {
  arrayBases,
  converterDataFormatoPadrao,
  converterLoja,
  converterMes,
  converterNomeLoja,
  fAnosDisponiveis,
  fAnosPorLoja,
} from "../../../util/loja.js";

import Select from "react-select";

import ButtonVoltar from "../../../components/ButtonVoltar.js";
import { vendasGrupoTabelaPorGrupo } from "../../../util/tables.js";
import TabelaNext from "../../../components/componentteste/TabelaNext.jsx";
import { FiltroPeriodo } from "../../../components/FiltroPeriodo/FiltroPeriodo.jsx";
import toast from "react-hot-toast";

import { PermissionsPage } from "../../../util/permissionsPage.js";
import { vendasService } from "../../../services/vendas.js";
import { useUserData } from "../../../hooks/useUserData.jsx";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { LoadingTable } from "../../../components/Loading/LoadingTable.jsx";
import { MultiSelectFilterBases } from "../../../components/FilterLojaMetas/MultiSelectFilterBases.jsx";
import {
  ButtonFilter,
  ButtonToday,
} from "../../../components/DatePikerFilter/styles.js";
import { Tab, Tabs } from "react-bootstrap";
import { optionsChartBarVendas, optionsChartBarVendasY } from "./chart.js";
import { colunasTabelaPorLoja } from "./colunas.js";

const colourStyles = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: state.isDisabled ? " whitesmoke" : "white",
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: " #eb0058",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#FFF",
    fontWeight: "bold",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "white",
    ":hover": {
      backgroundColor: "#ff0d6c",
      color: "white",
    },
  }),
};

function VendasPorGrupo() {
  const [isLoading, setIsLoading] = useState(true);
  const { userData } = useUserData();
  const accessLevel = userData?.nivelAcesso;
  const acessBase = userData?.baseAcesso;

  const [periodoInputInicio, setPeriodoInputInicio] = useState("");
  const [periodoInputFim, setPeriodoInputFim] = useState("");
  const [periodoInputInicioAux, setPeriodoInputInicioAux] = useState("");
  const [periodoInputFimAux, setPeriodoInputFimAux] = useState("");
  const [periodoAno, setPeriodoAno] = useState(false);

  const [anosDisponiveis, setAnosDisponiveis] = useState([]);
  const [lojasDisponiveis, setLojasDisponiveis] = useState([]);
  const [dadosGraficoAgrupado, setDadosGraficoAgrupado] = useState({
    labels: [],
    datasets: [],
  });
  const [dadosGraficoAgrupado1, setDadosGraficoAgrupado1] = useState({
    labels: [],
    datasets: [],
  });
  const [dadosGraficoAgrupado2, setDadosGraficoAgrupado2] = useState({
    labels: [],
    datasets: [],
  });

  const [dadosGerais, setDadosGerais] = useState(0);
  const [dadosGeraisGrupo, setDadosGeraisGrupo] = useState([]);

  const [filtrosAtivosLojasTexto, setFiltrosAtivosLojasTexto] = useState("");
  const [filtrosMesesSelecionados] = useState([]);
  const [filtrosAnosSelecionados, setFiltrosAnosSelecionados] = useState([]);
  const [filtrosLojasSelecionadas, setFiltrosLojasSelecionadas] = useState([]);
  const [lojasPresentesTabelaPorLoja, setLojasPresentesTabelaPorLoja] =
    useState([]);
  const [dadosTabelaPorLoja, setDadosTabelaPorLoja] = useState([]);

  const [lojaTable, setLojaTable] = useState(false);
  const [dadosParaTabela, setDadosParaTabela] = useState([]);
  const [auxDadosParaTabela, setAuxDadosParaTabela] = useState([]);
  const [dadosParaTabelaLoja, setDadosParaTabelaLoja] = useState([]);

  const [dadosUltimoPeriodo, setDadosUltimoPeriodo] = useState([]);
  const [exibeTabela, setExibeTabela] = useState(false);
  const [tipoPeriodo, setTipoPeriodo] = useState("");
  const [auxTipoPeriodo, setAuxTipoPeriodo] = useState("");
  const [filtradoPorLoja, setFiltradoPorLoja] = useState(false);
  const [grupoAtivo, setGrupoAtivo] = useState("");
  const [nivelAtivoDoGrafico, setNivelAtivoDoGrafico] = useState(0);
  const [auxAnoAtual, setAuxAnoAtual] = useState(0);
  const [auxAnoAnterior, setAuxAnoAnterior] = useState(0);

  const [dadosDisponiveis, setDadosDisponiveis] = useState(true);
  const [nivelAcesso, setNivelAcesso] = useState([]);
  const [base, setBase] = useState([]);
  const [basesDisponiveis, setBasesDisponiveis] = useState([]);
  const [basesSelecionadas, setBasesSelecionadas] = useState([]);

  useEffect(() => {
    if (nivelAcesso.length === 0) {
      buscarNivelAcesso();
      return;
    }
  }, [userData]);

  useEffect(() => {
    if (periodoAno) {
      preencherDados("ano");
    } else if (
      periodoInputInicio &&
      periodoInputInicio != "" &&
      periodoInputFim &&
      periodoInputFim != ""
    ) {
      preencherDados("input");
    }
  }, [periodoInputInicio, periodoInputFim, periodoAno, userData, base]);

  useEffect(() => {
    preencherInputPeriodo();
  }, []);

  useEffect(() => {
    if (filtrosAnosSelecionados.length > 0) {
      iniciaFiltroPorAno();
    }
  }, [filtrosAnosSelecionados]);

  useEffect(() => {
    if (filtradoPorLoja) {
      iniciaFiltroPorLoja();
    }
  }, [filtrosLojasSelecionadas]);

  useEffect(() => {
    if (grupoAtivo.trim() != "") {
      preencherDadosGrupoEspecifico(tipoPeriodo);
    }
  }, [grupoAtivo]);

  const buscarNivelAcesso = () => {
    if (accessLevel) {
      setNivelAcesso(accessLevel);
      const bases = arrayBases(acessBase);
      setBasesDisponiveis(bases);
      setBase(bases[0]?.codBase ? [bases[0].codBase] : []);
      setBasesSelecionadas(bases[0]?.codBase ? [bases[0].codBase] : []);
    } else {
      setIsLoading(false);
    }
  };

  function preencherInputPeriodo() {
    let dataHoje = new Date();
    let [inicioAno, hoje] = converterDataFormatoPadrao(dataHoje);

    setPeriodoInputInicioAux(inicioAno);
    setPeriodoInputFimAux(hoje);
    setPeriodoInputInicio(inicioAno);
    setPeriodoInputFim(hoje);
  }

  async function preencherDados(tipo) {
    setTipoPeriodo(tipo);
    let auxLojasSelecionadas = [];
    if (tipo != "mes") setAuxTipoPeriodo(tipo);
    setFiltradoPorLoja(false);
    setDadosGeraisGrupo([]);
    setGrupoAtivo("");
    setFiltrosAtivosLojasTexto("");
    setNivelAtivoDoGrafico(0);
    let lojasDisponiveisAux = [];
    lojasDisponiveis.map((item) => {
      lojasDisponiveisAux.push(item);
    });
    
    setLojasDisponiveis(lojasDisponiveisAux);
    if (tipoPeriodo == "mes") {
      tipo = auxTipoPeriodo;
    }
    if (tipo == "input" || tipo === "loja") {
      setExibeTabela(true);
      var anoAtual = periodoInputInicio.split("-")[0];
      var anoAnterior = parseInt(anoAtual) - 1;
      setAuxAnoAtual(anoAtual);
      setAuxAnoAnterior(anoAnterior);
    } else if (tipo == "ano") {
      var anoAtual = periodoAno.split(",");
      anoAtual = anoAtual.sort((a, b) => a - b);
      var anoAnterior;
      if (anoAtual.length > 1) {
        anoAnterior = anoAtual[anoAtual.length - 2];
      } else {
        anoAnterior = 0;
      }
      anoAtual = anoAtual[anoAtual.length - 1];
      setAuxAnoAtual(anoAtual);
      setAuxAnoAnterior(anoAnterior);
    }
    setIsLoading(true);
    if (!base) {
      setLojasDisponiveis([]);
      return;
    }
    window.scrollTo(0, 0);
    const toastId = toast.loading("Esperando dados do RAD");
    try {
      const response = await vendasService.listaVendasGrupo({
        inicio: periodoInputInicio,
        fim: periodoInputFim,
        bases: base,
      });

      if (response?.status !== 200) {
        toast.error("Não há conexão com o RAD", {
          duration: 7000,
          id: toastId,
          style: {
            borderRadius: "0.25rem",
            background: "#333",
            color: "#fff",
          },
        });
        setIsLoading(false);
        setDadosDisponiveis(false);
        return;
      }

      if (response?.status === 200) {
        toast.success("Dados recebidos", {
          id: toastId,
        });
        setAnosDisponiveis(fAnosDisponiveis(response.data.anos));
        var dataVendas = response.data.vendas;
        let dataVendasPeriodoAnterior = response.data.vendasPeriodoAnterior;
        dataVendas = dataVendas.sort((a, b) => {
          return a.codLoja - b.codLoja;
        });
        setDadosGerais(dataVendas);
        dataVendas.map((a) => {
          
          if (auxLojasSelecionadas.indexOf(converterLoja(a.codLoja)) == -1) {
            auxLojasSelecionadas.push(converterLoja(a.codLoja));
          }
        });

        if (filtrosLojasSelecionadas.length > 0) {
          dataVendas = dataVendas.filter((a) => {
            if (
              filtrosLojasSelecionadas.indexOf(converterLoja(a.codLoja)) >= 0
            ) {
              return true;
            } else {
              return false;
            }
          });
        }
        let grupoDeAnos = agruparPor(dataVendas, "ano");
        let grupoDeAnosArray = Object.entries(grupoDeAnos);
        let separadoPorGrupo = [];
        grupoDeAnosArray.map((item) => {
          let grupoDeLoja = agruparPor(item[1], "codGrp1");
          separadoPorGrupo.push(grupoDeLoja);
        });
        let resumoSeparadoPorGrupo = [];
        separadoPorGrupo.map((item) => {
          let item2 = Object.entries(item);
          item2.map((item3) => {
            let total = 0;
            let totalPedidos = 0;
            let ano;
            let codGrupo;
            let nomeGrupo;
            let totalCusto = 0;
            let totalLucro = 0;
            let porcentagemLucro = 0;
            item3[1].map((item4, index) => {
              if (index == 0) {
                ano = item4.ano;
                nomeGrupo = item4.nomeGrp1;
                codGrupo = item4.codGrp1;
              }
              totalPedidos += isNaN(parseInt(item4.totalPedidos))
                ? 0
                : parseInt(item4.totalPedidos);
              total += parseFloat(item4.vlrTotal);
              totalCusto += parseFloat(item4.vlrCusto);
              totalLucro += parseFloat(item4.vlrLucroBruto);
              porcentagemLucro += parseFloat(item4.vlrLucroBrutoPorcentagem);
            });
            porcentagemLucro = porcentagemLucro / item3[1].length;
            let resumoLojaAno = {
              ano: ano,
              codGrupo,
              nomeGrupo,
              total: total,
              totalPedidos: totalPedidos,
              totalCusto,
              totalLucro,
              porcentagemLucro,
            };
            resumoSeparadoPorGrupo.push(resumoLojaAno);
          });
        });
        var agrupado = agruparPor(resumoSeparadoPorGrupo, "ano");
        grupoDeAnosArray = Object.entries(agrupado);
        setDadosUltimoPeriodo(dataVendasPeriodoAnterior);
        preencherDadosGraficoAgrupado(
          grupoDeAnosArray,
          tipo,
          anoAtual,
          anoAnterior,
          dataVendasPeriodoAnterior
        );

        preencherDadosFornecedoresPorLoja(
          separadoPorGrupo,
          anoAtual,
          anoAnterior,
          dataVendasPeriodoAnterior
        );
        setLojasDisponiveis(auxLojasSelecionadas);
        setDadosDisponiveis(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setDadosDisponiveis(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function preencherDadosGrupoEspecifico(tipo) {
    setTipoPeriodo(tipo);
    let auxLojasSelecionadas = [];
    if (tipo != "mes") setAuxTipoPeriodo(tipo);
    setFiltradoPorLoja(false);
    if (tipoPeriodo == "mes") {
      tipo = auxTipoPeriodo;
    }
    if (tipo == "input") {
      setExibeTabela(true);
      var auxAnoAtual = periodoInputInicio.split("-")[0];
      var auxAnoAnterior = parseInt(auxAnoAtual) - 1;
      setAuxAnoAtual(auxAnoAtual);
      setAuxAnoAnterior(auxAnoAnterior);
    } else if (tipo == "ano") {
      var auxAnoAtual = periodoAno.split(",");
      auxAnoAtual = auxAnoAtual.sort((a, b) => a - b);
      var auxAnoAnterior;
      if (auxAnoAtual.length > 1) {
        auxAnoAnterior = auxAnoAtual[auxAnoAtual.length - 2];
      } else {
        auxAnoAnterior = 0;
      }
      auxAnoAtual = auxAnoAtual[auxAnoAtual.length - 1];
      setAuxAnoAtual(auxAnoAtual);
      setAuxAnoAnterior(auxAnoAnterior);
    }
    setIsLoading(true);
    window.scrollTo(0, 0);

    try {
      const response = await vendasService.listaVendasGrupo({
        inicio: periodoInputInicio,
        fim: periodoInputFim,
        grupoAtivo,
        bases: base,
      });

      if (response?.status === 200) {
        let dataVendas = response.data.vendas;
        let dataVendasPeriodoAnteriror = response.data.vendasPeriodoAnterior;
        dataVendas = dataVendas.sort((a, b) => {
          return a.codLoja - b.codLoja;
        });
        setDadosGeraisGrupo(dataVendas);
        dataVendas.map((a) => {
          if (auxLojasSelecionadas.indexOf(converterLoja(a.codLoja)) == -1) {
            auxLojasSelecionadas.push(converterLoja(a.codLoja));
          }
        });

        if (filtrosLojasSelecionadas.length > 0) {
          dataVendas = dataVendas.filter((a) => {
            if (
              filtrosLojasSelecionadas.indexOf(converterLoja(a.codLoja)) >= 0
            ) {
              return true;
            } else {
              return false;
            }
          });
        }
        let grupoDeAnos = agruparPor(dataVendas, "ano");
        let grupoDeAnosArray = Object.entries(grupoDeAnos);
        let separadoPorLoja = [];
        grupoDeAnosArray.map((item) => {
          let grupoDeLoja = agruparPor(item[1], "codLoja");
          separadoPorLoja.push(grupoDeLoja);
        });
        let resumoSeparadoPorLoja = [];
        separadoPorLoja.map((item) => {
          let item2 = Object.entries(item);
          item2.map((item3) => {
            let total = 0;
            let totalPedidos = 0;
            let ano;
            let codGrupo;
            let nomeGrupo;
            let totalCusto = 0;
            let totalLucro = 0;
            let porcentagemLucro = 0;
            let codLoja = 0;
            item3[1].map((item4, index) => {
              if (index == 0) {
                ano = item4.ano;
                nomeGrupo = item4.nomeGrp1;
                codGrupo = item4.codGrp1;
              }
              totalPedidos += parseInt(item4.totalPedidos);
              total += parseFloat(item4.vlrTotal);
              totalCusto += parseFloat(item4.vlrCusto);
              totalLucro += parseFloat(item4.vlrLucroBruto);
              porcentagemLucro += parseFloat(item4.vlrLucroBrutoPorcentagem);
              codLoja = item4.codLoja;
            });
            porcentagemLucro = porcentagemLucro / item3[1].length;
            let resumoLojaAno = {
              ano: ano,
              codGrupo,
              nomeGrupo,
              total: total,
              totalPedidos: totalPedidos,
              totalCusto,
              totalLucro,
              porcentagemLucro,
              codLoja,
            };
            resumoSeparadoPorLoja.push(resumoLojaAno);
          });
        });
        var agrupado = agruparPor(resumoSeparadoPorLoja, "ano");
        grupoDeAnosArray = Object.entries(agrupado);
        preencherDadosGraficoAgrupadoGrupo(
          grupoDeAnosArray,
          tipo,
          auxAnoAnterior,
          auxAnoAtual,
          dataVendasPeriodoAnteriror
        );
        setDadosDisponiveis(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setDadosDisponiveis(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function agruparPor(objetoArray, propriedade) {
    return objetoArray.reduce(function (acc, obj) {
      let key = obj[propriedade];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  function preencherDadosFornecedoresPorLoja(
    dados,
    anoAtual,
    anoAnterior,
    periodoAnterior
  ) {
    const lojasDisponiveisTabelaPorLoja = [];
    const dadosPorGrupo = [];
    dados.forEach((item) => {
      const grupos = Object.values(item);
      if (!Array.isArray(grupos) || grupos.length === 0) {
        return;
      }

      grupos.forEach((grupo) => {
        dadosPorGrupo.push({
          codGrupo: grupo[0]?.codGrp1 || "",
          nomeGrupo: grupo[0]?.nomeGrp1 || "",
          ano: grupo[0]?.ano || "",
          anoAtual: Number(grupo[0]?.ano) === Number(anoAtual),
          anoAnterior: Number(grupo[0]?.ano) === Number(anoAnterior),
          dados: grupo,
        });
        const lojas = Object.values(grupo);
        lojas.forEach((loja) => {
          if (!lojasDisponiveisTabelaPorLoja.includes(loja.codLoja)) {
            lojasDisponiveisTabelaPorLoja.push(loja.codLoja);
          }
        });
      });
    });
    setLojasPresentesTabelaPorLoja(
      lojasDisponiveisTabelaPorLoja.sort((a, b) => a - b)
    );
    const dadosPorGrupoAgrupado = agruparPor(dadosPorGrupo, "codGrupo");

    const fornecedoresNaoOrdenados = Object.values(dadosPorGrupoAgrupado);

    const fornecedoresOrdenados = fornecedoresNaoOrdenados.sort((a, b) => {
      const totalA = a[0]?.dados.reduce(
        (sum, item) => sum + (item.vlrTotal || 0),
        0
      );
      const totalB = b[0]?.dados.reduce(
        (sum, item) => sum + (item.vlrTotal || 0),
        0
      );
      return totalB - totalA;
    });

    setDadosTabelaPorLoja(fornecedoresOrdenados);
  }

  const LoadingTemp = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2500);
  };

  function iniciaFiltroPorAno() {
    var anosSelecionados = filtrosAnosSelecionados.join(",");
    setPeriodoAno(anosSelecionados);
  }

  function iniciaFiltroPorLoja() {
    preencherDadosVendasPorLoja();
  }

  async function preencherDadosGraficoAgrupado(
    dados,
    tipo,
    anoAtual,
    anoAnterior,
    dadosPeriodoAnterior
  ) {
    dados = dados.reverse();
    var label = [];
    var labelCompleta = [];
    var dataSets = [];
    var dadosTabelaAux = [];

    var dadosGrupoAux = [];
    const promise = await dados.map((item, i) => {
      var dadosGrupo = [];
      item[1] = item[1].sort((a, b) => {
        return b.total - a.total;
      });
      item[1].map((itemGrupo) => {
        var nomeGrupo = itemGrupo.nomeGrupo;
        if (i == 0) {
          label.push(nomeGrupo);
          labelCompleta.push(nomeGrupo);
          dadosGrupo.push(parseFloat(itemGrupo.total));
          dadosGrupoAux.push({ nomeGrupo: itemGrupo.nomeGrupo });
        } else {
          let jaExiste = label.indexOf(nomeGrupo);
          if (jaExiste < 0) {
            label.push(nomeGrupo);
          }
          jaExiste = label.indexOf(nomeGrupo);
          if (jaExiste < 0) {
            labelCompleta.push(nomeGrupo);
            dadosGrupo.push(parseFloat(itemGrupo.total));
            dadosGrupoAux.push({ nomeGrupo: itemGrupo.nomeGrupo });
          } else {
            dadosGrupo = insertAt(
              dadosGrupo,
              jaExiste,
              parseFloat(itemGrupo.total)
            );
            dadosGrupoAux = insertAt(dadosGrupoAux, jaExiste, {
              nomeGrupo: itemGrupo.nomeGrupo,
            });
          }
        }
        dadosTabelaAux.push(itemGrupo);
      });
      var cor =
        i == dados.length - 1
          ? "rgba(255, 194, 218, 1)"
          : i == dados.length - 2
          ? "rgba(91, 139, 252, 1)"
          : i == dados.length - 3
          ? "#5B8BFC"
          : i == dados.length - 4
          ? "#FFC2DA"
          : i == dados.length - 5
          ? ""
          : geraCorAleatoria();
      var datalabels;
      if (i == 1) {
        datalabels = {
          anchor: "end",
          display: true,
          color: cor,
          // rotation: -8,
          align: "end",
          formatter: function (value, context) {
            return parseFloat(value).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        };
      } else if (i == 0) {
        datalabels = {
          anchor: "end",
          display: true,
          color: cor,
          align: "end",
          // rotation: -8,
          formatter: function (value, context) {
            return parseFloat(value).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        };
      } else {
        datalabels = {
          formatter: function (value, context) {
            return "";
          },
        };
      }

      dataSets.push({
        label: item[0],
        data: dadosGrupo,
        backgroundColor: cor,
        datalabels: datalabels,
      });
    });

    if (dadosPeriodoAnterior && dadosPeriodoAnterior?.length > 0) {
      let periodoAnteriorAux = [];
      if (filtrosLojasSelecionadas.length > 0) {
        await dadosPeriodoAnterior.map((item) => {
          var nomeLoja = converterLoja(item.codLoja);
          if (filtrosLojasSelecionadas.indexOf(nomeLoja) >= 0) {
            periodoAnteriorAux.push(parseInt(item.vlrTotal));
          }
        });
        dataSets.push({
          label: "Periodo anterior",
          data: periodoAnteriorAux,
          backgroundColor: "#FFDB8A",
          datalabels: {
            anchor: "start",
            display: true,
            align: "start",
          },
        });
      } else {
        const dadosPeriodoAnteriorTemp = [];
        dadosGrupoAux.map((item) => {
          let dadosPeriodoAnteriorAux = dadosPeriodoAnterior.filter(
            (item2) => item2.nomeGrp1 === item.nomeGrupo
          );
          let dadosPeriodoAnteriorAuxSoma = dadosPeriodoAnteriorAux.reduce(
            (accum, item3) => (accum += Number(item3.vlrTotal)),
            0
          );
          dadosPeriodoAnteriorTemp.push(dadosPeriodoAnteriorAuxSoma);
        });

        dataSets.push({
          label: "Periodo anterior",
          data: dadosPeriodoAnteriorTemp,
          backgroundColor: "#FFDB8A",
          datalabels: {
            formatter: function (value, context) {
              return parseFloat(value).toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
            },
          },
        });
      }
    }

    await Promise.all(promise);
    const data = {
      labels: label,
      datasets: dataSets,
    };
    dadosTabelaAux = agruparPor(dadosTabelaAux, "nomeGrupo");
    dadosTabelaAux = Object.entries(dadosTabelaAux);
    //preencherColunasTabela(tipo)
    preencherDadosTabela(
      dadosTabelaAux,
      anoAtual,
      anoAnterior,
      tipo,
      dadosPeriodoAnterior
    );
    setDadosGraficoAgrupado(data);
  }

  function insertAt(array, index, element) {
    if (array.length == index && array.length == 0) {
      array.push(0);
      array.splice(index, 1, element);
      return array;
    }
    if (array.length < index) {
      do {
        array.push(0);
      } while (array.length < index);
      array.splice(index, 1, element);

      return array;
    } else {
      array.splice(index, 1, element);
      return array;
    }
  }

  async function preencherDadosGraficoAgrupadoGrupo(
    dados,
    tipo,
    anoAnterior,
    anoAtual,
    dadosPeriodoAnterior
  ) {
    dados = dados.reverse();
    let label = [];
    let labelCompleta = [];
    let dataSets = [];
    let dadosTabelaAux = [];
    let auxDataSets = [];
    var dadosGrupoAux = [];

    const promise = await dados.map((item, i) => {
      var dadosGrupo = [];
      var maiorDataSet = 0;
      auxDataSets.map((item) => {
        maiorDataSet = maiorDataSet < item.length ? item.length : maiorDataSet;
      });

      for (let i = 0; i < maiorDataSet.length; i++) {
        dadosGrupo.push(0);
      }
      item[1].map((itemGrupo) => {
        var nomeLoja = converterLoja(itemGrupo.codLoja);
        if (i == 0) {
          label.push(nomeLoja);

          labelCompleta.push(nomeLoja);
          dadosGrupo.push(parseFloat(itemGrupo.total));
          dadosGrupoAux.push({ codLoja: itemGrupo.codLoja });
        } else {
          let jaExiste = label.indexOf(nomeLoja);
          if (jaExiste < 0) {
            label.push(nomeLoja);
          }
          jaExiste = label.indexOf(nomeLoja);
          if (jaExiste < 0) {
            labelCompleta.push(nomeLoja);
            dadosGrupo.push(parseFloat(itemGrupo.total));
            dadosGrupoAux.push({ codLoja: itemGrupo.codLoja });
          } else {
            dadosGrupo = insertAt(
              dadosGrupo,
              jaExiste,
              parseFloat(itemGrupo.total)
            );
            dadosGrupoAux = insertAt(dadosGrupoAux, jaExiste, {
              codLoja: itemGrupo.codLoja,
            });
          }
        }

        dadosTabelaAux.push(itemGrupo);
      });
      var cor =
        i == dados.length - 1
          ? "rgba(255, 194, 218, 1)"
          : i == dados.length - 2
          ? "rgba(91, 139, 252, 1)"
          : i == dados.length - 3
          ? "#5B8BFC"
          : i == dados.length - 4
          ? "#FFC2DA"
          : i == dados.length - 5
          ? ""
          : geraCorAleatoria();
      var datalabels;
      if (item[0] == auxAnoAtual) {
        datalabels = {
          anchor: "end",
          display: true,
          color: "#000",
          align: "end",
          rotation: 0,
          formatter: function (value, context) {
            return parseFloat(value).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        };
      } else if (item[0] == auxAnoAnterior) {
        datalabels = {
          anchor: "start",
          display: true,
          color: cor,
          align: "start",
          formatter: function (value, context) {
            return parseFloat(value).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        };
      } else {
        datalabels = {
          formatter: function (value, context) {
            return "";
          },
        };
      }
      auxDataSets.push(dadosGrupo);
      dataSets.push({
        label: item[0],
        data: dadosGrupo,
        backgroundColor: cor,
        datalabels: datalabels,
      });
    });

    if (dadosPeriodoAnterior && dadosPeriodoAnterior?.length > 0) {
      let periodoAnteriorAux = [];
      if (filtrosLojasSelecionadas.length > 0) {
        await dadosPeriodoAnterior.map((item) => {
          var nomeLoja = converterLoja(item.codLoja);
          if (filtrosLojasSelecionadas.indexOf(nomeLoja) >= 0) {
            periodoAnteriorAux.push(parseInt(item.vlrTotal));
          }
        });
        dataSets.push({
          label: "Periodo anterior",
          data: periodoAnteriorAux,
          backgroundColor: "#FFDB8A",
          datalabels: {
            anchor: "start",
            display: true,
            align: "start",
          },
        });
      } else {
        const dadosPeriodoAnteriorTemp = [];
        dadosGrupoAux.map((item) => {
          let dadosPeriodoAnteriorAux = dadosPeriodoAnterior.filter(
            (item2) => item2.codLoja === item.codLoja
          );
          let dadosPeriodoAnteriorAuxSoma = dadosPeriodoAnteriorAux.reduce(
            (accum, item3) => (accum += Number(item3.vlrTotal)),
            0
          );
          dadosPeriodoAnteriorTemp.push(dadosPeriodoAnteriorAuxSoma);
        });

        dataSets.push({
          label: "Periodo anterior",
          data: dadosPeriodoAnteriorTemp,
          backgroundColor: "#FFDB8A",
          datalabels: {
            formatter: function (value, context) {
              return parseFloat(value).toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
            },
          },
        });
      }
    }

    await Promise.all(promise);
    const data = {
      labels: label,
      datasets: dataSets,
    };
    dadosTabelaAux = agruparPor(dadosTabelaAux, "codLoja");
    dadosTabelaAux = Object.entries(dadosTabelaAux);

    preencherDadosTabelaGrupo(dadosTabelaAux, dadosPeriodoAnterior);

    setDadosGraficoAgrupado1(data);
    setFiltrosAtivosLojasTexto(" Grupo " + grupoAtivo);
    setNivelAtivoDoGrafico(1);
  }
  function geraCorAleatoria() {
    let hexadecimais = "0123456789ABCDEF";
    let cor = "#";

    for (let i = 0; i < 6; i++) {
      cor += hexadecimais[Math.floor(Math.random() * 16)];
    }
    return cor;
  }
  function preencherDadosTabela(
    dados,
    anoAtual,
    anoAnterior,
    tipo,
    dadosPeriodoAnterior
  ) {
    let dadosTabela = [],
      representitivadadeFinal = 0;

    let quantidadeLojasAnoAtual = 0,
      quantidadeLojasAnoAnterior = 0;

    let qtdAnoAtualResumo = 0,
      vlrAnoAtualResumo = 0,
      custoTotalAnoAtualResumo = 0,
      custoTotalAnoAnteriorResumo = 0,
      desempenhoPAResumo = 0,
      qtdAnoAnteriorResumo = 0,
      vlrTotalAnoAnteriorResumo = 0,
      lucroBrutoTotalAnoAtualResumo = 0,
      lucroBrutoTotalAnoAnteriorResumo = 0,
      lucroPorcentagemAnoAtualResumo = 0,
      lucroPorcentagemAnoAnteriorResumo = 0,
      variacaoResumo = 0,
      valorTotalAnoAtualParaRepresentatividade = 0,
      qtdPeriodoAnteriorResumo = 0,
      lucroPeriodoAnteriorResumo = 0,
      porcentagemLucroPeriodoAnteriorResumo = 0,
      vlrTotalPeriodoAnteriorResumo = 0,
      custoPeriodoAnteriorResumo = 0;

    dados.map((item) => {
      item[1].map((item2, index2) => {
        if (item2.ano == anoAtual) {
          valorTotalAnoAtualParaRepresentatividade += parseFloat(item2.total);
        }
      });
    });

    if (dados.length > 0) {
      dados.map((item) => {
        let grupo = item[0];
        let qtdAnoAtual = 0,
          qtdAnoAnterior = 0,
          vlrAnoAtual = 0,
          vlrTotalAnoAnterior = 0,
          custoTotalAnoAtual = 0,
          custoTotalAnoAnterior = 0,
          lucroBrutoTotalAnoAtual = 0,
          desempPeriodoAnterior = 0,
          lucroBrutoTotalAnoAnterior = 0,
          lucroPorcentagemAnoAtual = 0,
          lucroPorcentagemAnoAnterior = 0,
          representatividadeGrupoAnoAtual = 0,
          representatividadeGrupoAnoAnterior = 0,
          variacao;
        const periodoAnteriorItem = dadosPeriodoAnterior?.filter(
          (item) => item?.nomeGrp1 === grupo
        );

        let vlrPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.vlrTotal);
            }, 0)
          : 0;
        let qtdPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.totalPedidos);
            }, 0)
          : 0;
        let custoPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.vlrCusto);
            }, 0)
          : 0;
        let lucroPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.vlrTotal - item.vlrCusto);
            }, 0)
          : 0;

        let porcentagemLucroPeriodoAnterior = parseFloat(
          parseFloat(
            Number(
              (vlrPeriodoAnterior - custoPeriodoAnterior) / vlrPeriodoAnterior
            ) * 100
          ).toFixed(2)
        );

        qtdPeriodoAnteriorResumo += qtdPeriodoAnterior;
        lucroPeriodoAnteriorResumo += lucroPeriodoAnterior;
        vlrTotalPeriodoAnteriorResumo += vlrPeriodoAnterior;
        custoPeriodoAnteriorResumo += custoPeriodoAnterior;

        var separaDoisUltimosAnos = [];
        if (item[1][0]) {
          separaDoisUltimosAnos.push(item[1][0]);
        }
        if (item[1][1]) {
          separaDoisUltimosAnos.push(item[1][1]);
        } else {
          let ano = (parseInt(item[1][0].ano) - 1).toString();
          let porcentagemLucro = 0;
          let total = 0;
          let totalCusto = 0;
          let totalLucro = 0;
          let totalPedidos = 0;
          separaDoisUltimosAnos.push({
            ano,
            total,
            totalPedidos,
            totalCusto,
            totalLucro,
            porcentagemLucro,
          });
        }
        separaDoisUltimosAnos.map((item2, index2) => {
          if (item2.ano == anoAtual) {
            qtdAnoAtual = parseInt(item2.totalPedidos);
            vlrAnoAtual = parseFloat(parseFloat(item2.total).toFixed(2));
            custoTotalAnoAtual = parseFloat(
              parseFloat(item2.totalCusto).toFixed(2)
            );
            lucroBrutoTotalAnoAtual = parseFloat(
              parseFloat(item2.total - item2.totalCusto).toFixed(2)
            );
            lucroPorcentagemAnoAtual = parseFloat(
              parseFloat(
                Number((item2.total - item2.totalCusto) / item2.total) * 100
              ).toFixed(2)
            );
            qtdAnoAtualResumo += qtdAnoAtual;
            vlrAnoAtualResumo += vlrAnoAtual;
            custoTotalAnoAtualResumo += custoTotalAnoAtual;
            lucroBrutoTotalAnoAtualResumo += lucroBrutoTotalAnoAtual;
            lucroPorcentagemAnoAtualResumo += lucroPorcentagemAnoAtual;
            if (qtdAnoAtual > 0) {
              quantidadeLojasAnoAtual++;
            }
          } else if (item2.ano == anoAnterior) {
            qtdAnoAnterior = parseInt(item2.totalPedidos);
            vlrTotalAnoAnterior = isNaN(item2.total)
              ? 0
              : parseFloat(parseFloat(item2.total).toFixed(2));
            custoTotalAnoAnterior = isNaN(item2.totalCusto)
              ? 0
              : parseFloat(parseFloat(item2.totalCusto).toFixed(2));
            lucroBrutoTotalAnoAnterior = isNaN(item2.totalLucro)
              ? 0
              : parseFloat(
                  parseFloat(item2.total - item2.totalCusto).toFixed(2)
                );
            lucroPorcentagemAnoAnterior = isNaN(item2.porcentagemLucro)
              ? 0
              : parseFloat(
                  parseFloat(
                    Number((item2.total - item2.totalCusto) / item2.total) * 100
                  ).toFixed(2)
                );

            qtdAnoAnteriorResumo += qtdAnoAnterior;
            vlrTotalAnoAnteriorResumo += vlrTotalAnoAnterior;
            custoTotalAnoAnteriorResumo += custoTotalAnoAnterior;
            lucroBrutoTotalAnoAnteriorResumo += lucroBrutoTotalAnoAnterior;
            lucroPorcentagemAnoAnteriorResumo += lucroPorcentagemAnoAnterior;
            if (qtdAnoAnterior > 0) {
              quantidadeLojasAnoAnterior++;
            }
          }
        });

        if (qtdAnoAnterior > 0) {
          variacao = parseFloat(
            ((vlrAnoAtual / vlrTotalAnoAnterior - 1) * 100).toFixed(2)
          );
        } else {
          variacao = 0;
        }

        representatividadeGrupoAnoAtual =
          (vlrAnoAtual / valorTotalAnoAtualParaRepresentatividade) * 100;
        representitivadadeFinal += representatividadeGrupoAnoAtual;

        const ticketMedioAnoAtual = qtdAnoAtual ? vlrAnoAtual / qtdAnoAtual : 0;
        const ticketMedioAnoAnterior = qtdAnoAnterior
          ? vlrTotalAnoAnterior / qtdAnoAnterior
          : 0;
        const ticketMedioPeriodoAnterior = qtdPeriodoAnterior
          ? vlrPeriodoAnterior / qtdPeriodoAnterior
          : 0;

        if (qtdPeriodoAnterior > 0) {
          desempPeriodoAnterior = parseFloat(
            ((vlrAnoAtual / vlrPeriodoAnterior - 1) * 100).toFixed(2)
          );
        } else {
          desempPeriodoAnterior = 0;
        }

        dadosTabela.push({
          grupo: grupo,
          qtdAnoAtual: qtdAnoAtual,
          qtdAnoAnterior: qtdAnoAnterior,
          vlrAnoAtual: vlrAnoAtual,
          vlrTotalAnoAnterior: vlrTotalAnoAnterior,
          custoTotalAtual: custoTotalAnoAtual,
          custoTotalAnterior: custoTotalAnoAnterior,
          lucroBrutoAtual: lucroBrutoTotalAnoAtual,
          lucroBrutoAnterior: lucroBrutoTotalAnoAnterior,
          lucro: lucroPorcentagemAnoAtual,
          lucroAnterior: lucroPorcentagemAnoAnterior,
          variacao: variacao,
          representitivadadeAtual: representatividadeGrupoAnoAtual,
          vlrPeriodoAnterior: vlrPeriodoAnterior,
          qtdPeriodoAnterior: qtdPeriodoAnterior,
          desempPeriodoAnterior: desempPeriodoAnterior,
          lucroPeriodoAnterior: lucroPeriodoAnterior,
          custoPeriodoAnterior: custoPeriodoAnterior,
          porcentagemLucroPeriodoAnterior: porcentagemLucroPeriodoAnterior,
          ticketMedioAnoAtual,
          ticketMedioAnoAnterior,
          ticketMedioPeriodoAnterior,
        });
      });
    }
    lucroPorcentagemAnoAtualResumo = parseFloat(
      (lucroPorcentagemAnoAtualResumo / quantidadeLojasAnoAtual).toFixed(2)
    );
    lucroPorcentagemAnoAnteriorResumo = parseFloat(
      (lucroPorcentagemAnoAnteriorResumo / quantidadeLojasAnoAnterior).toFixed(
        2
      )
    );
    variacaoResumo = parseFloat(
      ((vlrAnoAtualResumo / vlrTotalAnoAnteriorResumo - 1) * 100).toFixed(2)
    );

    porcentagemLucroPeriodoAnteriorResumo =
      (custoPeriodoAnteriorResumo / vlrTotalPeriodoAnteriorResumo) * 100;

    const ticketMedioAnoAtualResumo = qtdAnoAtualResumo
      ? vlrAnoAtualResumo / qtdAnoAtualResumo
      : 0;
    const ticketMedioAnoAnteriorResumo = qtdAnoAnteriorResumo
      ? vlrTotalAnoAnteriorResumo / qtdAnoAnteriorResumo
      : 0;
    const ticketMedioPeriodoAnteriorResumo = qtdPeriodoAnteriorResumo
      ? vlrTotalPeriodoAnteriorResumo / qtdPeriodoAnteriorResumo
      : 0;

    desempenhoPAResumo = parseFloat(
      ((vlrAnoAtualResumo / vlrTotalPeriodoAnteriorResumo - 1) * 100).toFixed(2)
    );

    lucroBrutoTotalAnoAtualResumo =
      vlrAnoAtualResumo - custoTotalAnoAtualResumo;
    lucroBrutoTotalAnoAnteriorResumo =
      vlrTotalAnoAnteriorResumo - custoTotalAnoAnteriorResumo;
    lucroPeriodoAnteriorResumo =
      vlrTotalPeriodoAnteriorResumo - custoPeriodoAnteriorResumo;

    lucroPorcentagemAnoAtualResumo = vlrAnoAtualResumo
      ? (lucroBrutoTotalAnoAtualResumo / vlrAnoAtualResumo) * 100
      : 0;
    lucroPorcentagemAnoAnteriorResumo = vlrTotalAnoAnteriorResumo
      ? (lucroBrutoTotalAnoAnteriorResumo / vlrTotalAnoAnteriorResumo) * 100
      : 0;
    porcentagemLucroPeriodoAnteriorResumo = vlrTotalPeriodoAnteriorResumo
      ? (lucroPeriodoAnteriorResumo / vlrTotalPeriodoAnteriorResumo) * 100
      : 0;
    dadosTabela.push({
      grupo: "Total",
      qtdAnoAtual: qtdAnoAtualResumo,
      qtdAnoAnterior: qtdAnoAnteriorResumo,
      vlrAnoAtual: vlrAnoAtualResumo,
      vlrTotalAnoAnterior: vlrTotalAnoAnteriorResumo,
      custoTotalAtual: custoTotalAnoAtualResumo,
      custoTotalAnterior: custoTotalAnoAnteriorResumo,
      lucroBrutoAtual: lucroBrutoTotalAnoAtualResumo,
      lucroBrutoAnterior: lucroBrutoTotalAnoAnteriorResumo,
      lucro: lucroPorcentagemAnoAtualResumo,
      lucroAnterior: lucroPorcentagemAnoAnteriorResumo,
      variacao: variacaoResumo,
      representitivadadeAtual: representitivadadeFinal,
      vlrPeriodoAnterior: vlrTotalPeriodoAnteriorResumo,
      qtdPeriodoAnterior: qtdPeriodoAnteriorResumo,
      lucroPeriodoAnterior: lucroPeriodoAnteriorResumo,
      custoPeriodoAnterior: custoPeriodoAnteriorResumo,
      porcentagemLucroPeriodoAnterior: porcentagemLucroPeriodoAnteriorResumo,
      ticketMedioAnoAtual: ticketMedioAnoAtualResumo,
      desempPeriodoAnterior: desempenhoPAResumo,
      ticketMedioAnoAnterior: ticketMedioAnoAnteriorResumo,
      ticketMedioPeriodoAnterior: ticketMedioPeriodoAnteriorResumo,
    });
    setDadosParaTabela(dadosTabela);

    setAuxDadosParaTabela(dadosTabela);
  }
  function preencherDadosTabelaGrupo(dados, dadosPeriodoAnterior) {
    let dadosTabela = [],
      representitivadadeFinal = 0;

    let quantidadeLojasAnoAtual = 0,
      quantidadeLojasAnoAnterior = 0;
    let qtdAnoAtualResumo = 0,
      vlrAnoAtualResumo = 0,
      desempenhoPAResumo = 0,
      custoTotalAnoAtualResumo = 0,
      custoTotalAnoAnteriorResumo = 0,
      qtdAnoAnteriorResumo = 0,
      vlrTotalAnoAnteriorResumo = 0,
      lucroBrutoTotalAnoAtualResumo = 0,
      lucroBrutoTotalAnoAnteriorResumo = 0,
      lucroPorcentagemAnoAtualResumo = 0,
      lucroPorcentagemAnoAnteriorResumo = 0,
      variacaoResumo = 0,
      qtdPeriodoAnteriorResumo = 0,
      lucroPeriodoAnteriorResumo = 0,
      porcentagemLucroPeriodoAnteriorResumo = 0,
      valorTotalAnoAtualParaRepresentatividade = 0,
      vlrTotalPeriodoAnteriorResumo = 0,
      custoPeriodoAnteriorResumo = 0;

    dados.forEach((item) => {
      item[1].forEach((item2) => {
        if (item2.ano == auxAnoAtual) {
          valorTotalAnoAtualParaRepresentatividade += parseFloat(item2.total);
        }
      });
    });

    if (dados.length > 0) {
      dados.forEach((item) => {
        let loja = item[0];
        let qtdAnoAtual = 0,
          qtdAnoAnterior = 0,
          vlrAnoAtual = 0,
          vlrTotalAnoAnterior = 0,
          desempPeriodoAnterior = 0,
          custoTotalAnoAtual = 0,
          custoTotalAnoAnterior = 0,
          lucroBrutoTotalAnoAtual = 0,
          lucroBrutoTotalAnoAnterior = 0,
          lucroPorcentagemAnoAtual = 0,
          lucroPorcentagemAnoAnterior = 0,
          representatividadeGrupoAnoAtual = 0,
          variacao = 0;

        const periodoAnteriorItem = dadosPeriodoAnterior?.filter(
          (item) => item?.codLoja === loja
        );

        let vlrPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.vlrTotal);
            }, 0)
          : 0;
        let qtdPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.totalPedidos);
            }, 0)
          : 0;
        let custoPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.vlrCusto);
            }, 0)
          : 0;
        let lucroPeriodoAnterior = periodoAnteriorItem
          ? periodoAnteriorItem.reduce((acc, item) => {
              return acc + Number(item.vlrLucroBruto);
            }, 0)
          : 0;

        qtdPeriodoAnteriorResumo += qtdPeriodoAnterior;
        lucroPeriodoAnteriorResumo += lucroPeriodoAnterior;
        vlrTotalPeriodoAnteriorResumo += vlrPeriodoAnterior;
        custoPeriodoAnteriorResumo += custoPeriodoAnterior;

        var separaDoisUltimosAnos = [];
        if (item[1][0]) {
          separaDoisUltimosAnos.push(item[1][0]);
        }
        if (item[1][1]) {
          separaDoisUltimosAnos.push(item[1][1]);
        } else {
          let ano = (parseInt(item[1][0].ano) - 1).toString();
          let porcentagemLucro = 0;
          let total = 0;
          let totalCusto = 0;
          let totalLucro = 0;
          let totalPedidos = 0;
          separaDoisUltimosAnos.push({
            ano,
            total,
            totalPedidos,
            totalCusto,
            totalLucro,
            porcentagemLucro,
          });
        }
        separaDoisUltimosAnos.forEach((item2, index2) => {
          if (item2.ano == auxAnoAtual) {
            qtdAnoAtual = parseInt(item2.totalPedidos);
            vlrAnoAtual = parseFloat(parseFloat(item2.total).toFixed(2));
            custoTotalAnoAtual = parseFloat(
              parseFloat(item2.totalCusto).toFixed(2)
            );
            lucroBrutoTotalAnoAtual = parseFloat(
              parseFloat(item2.total - item2.totalCusto).toFixed(2)
            );
            lucroPorcentagemAnoAtual = parseFloat(
              parseFloat(
                Number((item2.total - item2.totalCusto) / item2.total) * 100
              ).toFixed(2)
            );

            qtdAnoAtualResumo += qtdAnoAtual;
            vlrAnoAtualResumo += vlrAnoAtual;
            custoTotalAnoAtualResumo += custoTotalAnoAtual;
            lucroBrutoTotalAnoAtualResumo += lucroBrutoTotalAnoAtual;
            lucroPorcentagemAnoAtualResumo += lucroPorcentagemAnoAtual;
            quantidadeLojasAnoAtual++;
          } else if (item2.ano == auxAnoAnterior) {
            qtdAnoAnterior = parseInt(item2.totalPedidos);
            vlrTotalAnoAnterior = isNaN(item2.total)
              ? 0
              : parseFloat(parseFloat(item2.total).toFixed(2));
            custoTotalAnoAnterior = isNaN(item2.totalCusto)
              ? 0
              : parseFloat(parseFloat(item2.totalCusto).toFixed(2));
            lucroBrutoTotalAnoAnterior = isNaN(item2.totalLucro)
              ? 0
              : parseFloat(parseFloat(item2.totalLucro).toFixed(2));
            lucroPorcentagemAnoAnterior = isNaN(item2.porcentagemLucro)
              ? 0
              : parseFloat(
                  parseFloat(
                    Number((item2.total - item2.totalCusto) / item2.total) * 100
                  ).toFixed(2)
                );

            qtdAnoAnteriorResumo += qtdAnoAnterior;
            vlrTotalAnoAnteriorResumo += vlrTotalAnoAnterior;
            custoTotalAnoAnteriorResumo += custoTotalAnoAnterior;
            lucroBrutoTotalAnoAnteriorResumo += lucroBrutoTotalAnoAnterior;
            lucroPorcentagemAnoAnteriorResumo += lucroPorcentagemAnoAnterior;
            quantidadeLojasAnoAnterior++;
          }
        });
        if (qtdAnoAnterior > 0) {
          variacao = parseFloat(
            ((vlrAnoAtual / vlrTotalAnoAnterior - 1) * 100).toFixed(2)
          );
        } else {
          variacao = 0;
        }

        const ticketMedioAnoAtual = qtdAnoAtual ? vlrAnoAtual / qtdAnoAtual : 0;
        const ticketMedioAnoAnterior = qtdAnoAnterior
          ? vlrTotalAnoAnterior / qtdAnoAnterior
          : 0;
        const ticketMedioPeriodoAnterior = qtdPeriodoAnterior
          ? vlrPeriodoAnterior / qtdPeriodoAnterior
          : 0;

        if (qtdPeriodoAnterior > 0) {
          desempPeriodoAnterior = parseFloat(
            ((vlrAnoAtual / vlrPeriodoAnterior - 1) * 100).toFixed(2)
          );
        } else {
          desempPeriodoAnterior = 0;
        }

        representatividadeGrupoAnoAtual =
          (vlrAnoAtual / valorTotalAnoAtualParaRepresentatividade) * 100;
        representitivadadeFinal += representatividadeGrupoAnoAtual;

        dadosTabela.push({
          loja: loja,
          qtdAnoAtual: qtdAnoAtual,
          qtdAnoAnterior: qtdAnoAnterior,
          vlrAnoAtual: vlrAnoAtual,
          vlrTotalAnoAnterior: vlrTotalAnoAnterior,
          custoTotalAtual: custoTotalAnoAtual,
          custoTotalAnterior: custoTotalAnoAnterior,
          lucroBrutoAtual: lucroBrutoTotalAnoAtual,
          lucroBrutoAnterior: lucroBrutoTotalAnoAnterior,
          lucro: lucroPorcentagemAnoAtual,
          representitivadadeAtual: representatividadeGrupoAnoAtual,
          lucroAnterior: lucroPorcentagemAnoAnterior,
          variacao: variacao,
          vlrPeriodoAnterior: vlrTotalPeriodoAnteriorResumo,
          qtdPeriodoAnterior: qtdPeriodoAnteriorResumo,
          lucroPeriodoAnterior: lucroPeriodoAnteriorResumo,
          custoPeriodoAnterior: custoPeriodoAnteriorResumo,
          porcentagemLucroPeriodoAnterior:
            porcentagemLucroPeriodoAnteriorResumo,
          desempPeriodoAnterior: desempPeriodoAnterior,
          ticketMedioAnoAtual,
          ticketMedioAnoAnterior,
          ticketMedioPeriodoAnterior,
        });
      });
    }
    lucroPorcentagemAnoAtualResumo = parseFloat(
      (lucroPorcentagemAnoAtualResumo / quantidadeLojasAnoAtual).toFixed(2)
    );
    lucroPorcentagemAnoAnteriorResumo = parseFloat(
      (lucroPorcentagemAnoAnteriorResumo / quantidadeLojasAnoAnterior).toFixed(
        2
      )
    );
    variacaoResumo = parseFloat(
      ((vlrAnoAtualResumo / vlrTotalAnoAnteriorResumo - 1) * 100).toFixed(2)
    );

    porcentagemLucroPeriodoAnteriorResumo =
      (custoPeriodoAnteriorResumo / vlrTotalPeriodoAnteriorResumo) * 100;

    const ticketMedioAnoAtualResumo = qtdAnoAtualResumo
      ? vlrAnoAtualResumo / qtdAnoAtualResumo
      : 0;
    const ticketMedioAnoAnteriorResumo = qtdAnoAnteriorResumo
      ? vlrTotalAnoAnteriorResumo / qtdAnoAnteriorResumo
      : 0;
    const ticketMedioPeriodoAnteriorResumo = qtdPeriodoAnteriorResumo
      ? vlrTotalPeriodoAnteriorResumo / qtdPeriodoAnteriorResumo
      : 0;

    desempenhoPAResumo = parseFloat(
      ((vlrAnoAtualResumo / vlrTotalPeriodoAnteriorResumo - 1) * 100).toFixed(2)
    );

    lucroBrutoTotalAnoAtualResumo =
      vlrAnoAtualResumo - custoTotalAnoAtualResumo;
    lucroBrutoTotalAnoAnteriorResumo =
      vlrTotalAnoAnteriorResumo - custoTotalAnoAnteriorResumo;
    lucroPeriodoAnteriorResumo =
      vlrTotalPeriodoAnteriorResumo - custoPeriodoAnteriorResumo;

    lucroPorcentagemAnoAtualResumo = vlrAnoAtualResumo
      ? (lucroBrutoTotalAnoAtualResumo / vlrAnoAtualResumo) * 100
      : 0;
    lucroPorcentagemAnoAnteriorResumo = vlrTotalAnoAnteriorResumo
      ? (lucroBrutoTotalAnoAnteriorResumo / vlrTotalAnoAnteriorResumo) * 100
      : 0;
    porcentagemLucroPeriodoAnteriorResumo = vlrTotalPeriodoAnteriorResumo
      ? (lucroPeriodoAnteriorResumo / vlrTotalPeriodoAnteriorResumo) * 100
      : 0;

    dadosTabela.push({
      loja: "Total",
      qtdAnoAtual: qtdAnoAtualResumo,
      qtdAnoAnterior: qtdAnoAnteriorResumo,
      vlrAnoAtual: vlrAnoAtualResumo,
      vlrTotalAnoAnterior: vlrTotalAnoAnteriorResumo,
      custoTotalAtual: custoTotalAnoAtualResumo,
      custoTotalAnterior: custoTotalAnoAnteriorResumo,
      lucroBrutoAtual: lucroBrutoTotalAnoAtualResumo,
      lucroBrutoAnterior: lucroBrutoTotalAnoAnteriorResumo,
      lucro: lucroPorcentagemAnoAtualResumo,
      lucroAnterior: lucroPorcentagemAnoAnteriorResumo,
      variacao: variacaoResumo,
      vlrPeriodoAnterior: vlrTotalPeriodoAnteriorResumo,
      qtdPeriodoAnterior: qtdPeriodoAnteriorResumo,
      lucroPeriodoAnterior: lucroPeriodoAnteriorResumo,
      custoPeriodoAnterior: custoPeriodoAnteriorResumo,
      porcentagemLucroPeriodoAnterior: porcentagemLucroPeriodoAnteriorResumo,
      desempPeriodoAnterior: desempenhoPAResumo,
      representitivadadeAtual: representitivadadeFinal,
      ticketMedioAnoAtual: ticketMedioAnoAtualResumo,
      ticketMedioAnoAnterior: ticketMedioAnoAnteriorResumo,
      ticketMedioPeriodoAnterior: ticketMedioPeriodoAnteriorResumo,
    });
    setDadosParaTabela(dadosTabela);
    setDadosParaTabelaLoja(dadosTabela);
  }

  function preencherDadosTabelaMes(dados) {
    let dadosTabela = [],
      representitivadadeFinal = 0;
    let quantidadeLojasAnoAtual = 0,
      quantidadeLojasAnoAnterior = 0;
    let qtdAnoAtualResumo = 0,
      vlrAnoAtualResumo = 0,
      custoTotalAnoAtualResumo = 0,
      custoTotalAnoAnteriorResumo = 0,
      qtdAnoAnteriorResumo = 0,
      vlrTotalAnoAnteriorResumo = 0,
      lucroBrutoTotalAnoAtualResumo = 0,
      lucroBrutoTotalAnoAnteriorResumo = 0,
      lucroPorcentagemAnoAtualResumo = 0,
      valorTotalAnoAtualParaRepresentatividade = 0,
      lucroPorcentagemAnoAnteriorResumo = 0,
      variacaoResumo = 0;
    dados.forEach((item) => {
      item[1].forEach((item2) => {
        if (item2.ano == auxAnoAtual) {
          valorTotalAnoAtualParaRepresentatividade += parseFloat(
            item2.vlrTotal
          );
        }
      });
    });

    if (dados.length > 0) {
      dados.forEach((item) => {
        let mes = parseInt(item[0]);
        let qtdAnoAtual = 0,
          qtdAnoAnterior = 0,
          vlrAnoAtual = 0,
          vlrTotalAnoAnterior = 0,
          custoTotalAnoAtual = 0,
          custoTotalAnoAnterior = 0,
          lucroBrutoTotalAnoAtual = 0,
          lucroBrutoTotalAnoAnterior = 0,
          lucroPorcentagemAnoAtual = 0,
          lucroPorcentagemAnoAnterior = 0,
          representatividadeGrupoAnoAtual = 0,
          variacao = 0;
        item[1].forEach((item2, index2) => {
          if (item2.ano == auxAnoAtual) {
            qtdAnoAtual = parseInt(item2.totalPedidos);
            vlrAnoAtual = isNaN(item2.vlrTotal)
              ? 0
              : parseFloat(parseFloat(item2.vlrTotal).toFixed(2));
            custoTotalAnoAtual = isNaN(item2.vlrCusto)
              ? 0
              : parseFloat(parseFloat(item2.vlrCusto).toFixed(2));
            lucroBrutoTotalAnoAtual = isNaN(item2.vlrLucroBruto)
              ? 0
              : parseFloat(
                  parseFloat(item2.total - item2.totalCusto).toFixed(2)
                );
            lucroPorcentagemAnoAtual = isNaN(item2.vlrLucroBrutoPorcentagem)
              ? 0
              : parseFloat(
                  parseFloat(
                    Number((item2.total - item2.totalCusto) / item2.total) * 100
                  ).toFixed(2)
                );
            qtdAnoAtualResumo += qtdAnoAtual;
            vlrAnoAtualResumo += vlrAnoAtual;
            custoTotalAnoAtualResumo += custoTotalAnoAtual;
            lucroBrutoTotalAnoAtualResumo += lucroBrutoTotalAnoAtual;
            lucroPorcentagemAnoAtualResumo += lucroPorcentagemAnoAtual;
            if (qtdAnoAtual > 0) {
              quantidadeLojasAnoAtual++;
            }
          } else if (item2.ano == auxAnoAnterior) {
            qtdAnoAnterior = isNaN(item2.totalPedidos)
              ? 0
              : parseInt(item2.totalPedidos);
            vlrTotalAnoAnterior = isNaN(item2.vlrTotal)
              ? 0
              : parseFloat(parseFloat(item2.vlrTotal).toFixed(2));
            custoTotalAnoAnterior = isNaN(item2.vlrCusto)
              ? 0
              : parseFloat(parseFloat(item2.vlrCusto).toFixed(2));
            lucroBrutoTotalAnoAnterior = isNaN(item2.vlrLucroBruto)
              ? 0
              : parseFloat(parseFloat(item2.vlrLucroBruto).toFixed(2));
            lucroPorcentagemAnoAnterior = isNaN(item2.vlrLucroBrutoPorcentagem)
              ? 0
              : parseFloat(
                  parseFloat(
                    Number((item2.total - item2.totalCusto) / item2.total) * 100
                  ).toFixed(2)
                );
            qtdAnoAnteriorResumo += qtdAnoAnterior;
            vlrTotalAnoAnteriorResumo += vlrTotalAnoAnterior;
            custoTotalAnoAnteriorResumo += custoTotalAnoAnterior;
            lucroBrutoTotalAnoAnteriorResumo += lucroBrutoTotalAnoAnterior;
            lucroPorcentagemAnoAnteriorResumo += lucroPorcentagemAnoAnterior;
            if (qtdAnoAnterior > 0) {
              quantidadeLojasAnoAnterior++;
            }
          }
        });
        if (vlrTotalAnoAnterior > 0) {
          variacao = parseFloat(
            ((vlrAnoAtual / vlrTotalAnoAnterior - 1) * 100).toFixed(2)
          );
        } else {
          variacao = 0;
        }

        representatividadeGrupoAnoAtual =
          (vlrAnoAtual / valorTotalAnoAtualParaRepresentatividade) * 100;
        representitivadadeFinal += representatividadeGrupoAnoAtual;

        const ticketMedioAnoAtual = qtdAnoAtual ? vlrAnoAtual / qtdAnoAtual : 0;
        const ticketMedioAnoAnterior = qtdAnoAnterior
          ? vlrTotalAnoAnterior / qtdAnoAnterior
          : 0;

        dadosTabela.push({
          mes: mes,
          qtdAnoAtual: qtdAnoAtual,
          qtdAnoAnterior: qtdAnoAnterior,
          vlrAnoAtual: vlrAnoAtual,
          vlrTotalAnoAnterior: vlrTotalAnoAnterior,
          custoTotalAtual: custoTotalAnoAtual,
          representitivadadeAtual: representatividadeGrupoAnoAtual,
          custoTotalAnterior: custoTotalAnoAnterior,
          lucroBrutoAtual: lucroBrutoTotalAnoAtual,
          lucroBrutoAnterior: lucroBrutoTotalAnoAnterior,
          lucro: lucroPorcentagemAnoAtual,
          lucroAnterior: lucroPorcentagemAnoAnterior,
          variacao: variacao,
          ticketMedioAnoAtual,
          ticketMedioAnoAnterior,
        });
      });
    }
    lucroPorcentagemAnoAtualResumo = parseFloat(
      (lucroPorcentagemAnoAtualResumo / quantidadeLojasAnoAtual).toFixed(2)
    );
    lucroPorcentagemAnoAnteriorResumo = parseFloat(
      (lucroPorcentagemAnoAnteriorResumo / quantidadeLojasAnoAnterior).toFixed(
        2
      )
    );
    variacaoResumo = parseFloat(
      ((vlrAnoAtualResumo / vlrTotalAnoAnteriorResumo - 1) * 100).toFixed(2)
    );

    const ticketMedioAnoAtualResumo = qtdAnoAtualResumo
      ? vlrAnoAtualResumo / qtdAnoAtualResumo
      : 0;
    const ticketMedioAnoAnteriorResumo = qtdAnoAnteriorResumo
      ? vlrTotalAnoAnteriorResumo / qtdAnoAnteriorResumo
      : 0;

    lucroBrutoTotalAnoAtualResumo =
      vlrAnoAtualResumo - custoTotalAnoAtualResumo;
    lucroBrutoTotalAnoAnteriorResumo =
      vlrTotalAnoAnteriorResumo - custoTotalAnoAnteriorResumo;

    lucroPorcentagemAnoAtualResumo = vlrAnoAtualResumo
      ? (lucroBrutoTotalAnoAtualResumo / vlrAnoAtualResumo) * 100
      : 0;
    lucroPorcentagemAnoAnteriorResumo = vlrTotalAnoAnteriorResumo
      ? (lucroBrutoTotalAnoAnteriorResumo / vlrTotalAnoAnteriorResumo) * 100
      : 0;

    dadosTabela.push({
      mes: "Total",
      qtdAnoAtual: qtdAnoAtualResumo,
      qtdAnoAnterior: qtdAnoAnteriorResumo,
      vlrAnoAtual: vlrAnoAtualResumo,
      vlrTotalAnoAnterior: vlrTotalAnoAnteriorResumo,
      custoTotalAtual: custoTotalAnoAtualResumo,
      custoTotalAnterior: custoTotalAnoAnteriorResumo,
      lucroBrutoAtual: lucroBrutoTotalAnoAtualResumo,
      lucroBrutoAnterior: lucroBrutoTotalAnoAnteriorResumo,
      lucro: lucroPorcentagemAnoAtualResumo,
      lucroAnterior: lucroPorcentagemAnoAnteriorResumo,
      representitivadadeAtual: representitivadadeFinal,
      variacao: variacaoResumo,
      ticketMedioAnoAtual: ticketMedioAnoAtualResumo,
      ticketMedioAnoAnterior: ticketMedioAnoAnteriorResumo,
    });

    setDadosParaTabela(dadosTabela);
  }

  async function preencherDadosGraficoAgrupadoGrupoMes(loja) {
    let codLoja = converterNomeLoja(loja);
    let dados = dadosGeraisGrupo;
    dados = dados.filter((a) => {
      return a.codLoja == codLoja ? true : false;
    });
    let grupoDeAnos = agruparPor(dados, "ano");
    let grupoDeAnosArray = Object.entries(grupoDeAnos);
    dados = grupoDeAnosArray;
    dados = dados.reverse();
    let label = [];
    let labelCompleta = [];
    let dataSets = [];
    let dadosTabelaAux = [];
    let auxDataSets = [];
    const promise = await dados.map((item, i) => {
      let dadosGrupo = [];
      let maiorDataSet = 0;
      auxDataSets.map((item) => {
        maiorDataSet = maiorDataSet < item.length ? item.length : maiorDataSet;
      });

      for (let i = 0; i < maiorDataSet.length; i++) {
        dadosGrupo.push(0);
      }
      item[1] = item[1].sort((a, b) => {
        return a.mes - b.mes;
      });

      item[1].map((itemGrupo) => {
        let nomeMes = converterMes(itemGrupo.mes);
        if (filtrosMesesSelecionados.length > 0) {
          if (filtrosMesesSelecionados.indexOf(nomeMes) >= 0) {
            if (i == 0) {
              label.push(nomeMes);
              labelCompleta.push(nomeMes);
              dadosGrupo.push(parseFloat(itemGrupo.vlrTotal));
            } else {
              let jaExiste = label.indexOf(nomeMes);
              if (jaExiste < 0) {
                label.push(nomeMes);
                labelCompleta.push(nomeMes);
              }
              jaExiste = label.indexOf(nomeMes);
              if (jaExiste < 0) {
                dadosGrupo.push(parseFloat(itemGrupo.vlrTotal));
              } else {
                dadosGrupo = insertAt(
                  dadosGrupo,
                  jaExiste,
                  parseFloat(itemGrupo.vlrTotal)
                );
              }
            }
            dadosTabelaAux.push(itemGrupo);
          } else {
            let jaExiste = labelCompleta.indexOf(nomeMes);
            if (jaExiste < 0) {
              labelCompleta.push(nomeMes);
            }
          }
        } else {
          if (i == 0) {
            label.push(nomeMes);
            labelCompleta.push(nomeMes);
            dadosGrupo.push(parseFloat(itemGrupo.vlrTotal));
          } else {
            let jaExiste = label.indexOf(nomeMes);
            if (jaExiste < 0) {
              label.push(nomeMes);
              labelCompleta.push(nomeMes);
            }
            jaExiste = label.indexOf(nomeMes);
            if (jaExiste < 0) {
              dadosGrupo.push(parseFloat(itemGrupo.vlrTotal));
            } else {
              dadosGrupo = insertAt(
                dadosGrupo,
                jaExiste,
                parseFloat(itemGrupo.vlrTotal)
              );
            }
          }
          dadosTabelaAux.push(itemGrupo);
        }
      });

      let cor =
        i == dados.length - 1
          ? "rgba(255, 194, 218, 1)"
          : i == dados.length - 2
          ? "rgba(91, 139, 252, 1)"
          : i == dados.length - 3
          ? "#5B8BFC"
          : i == dados.length - 4
          ? "#FFC2DA"
          : i == dados.length - 5
          ? ""
          : geraCorAleatoria();
      let datalabels;
      if (item[0] == auxAnoAtual) {
        datalabels = {
          anchor: "end",
          display: true,
          color: "#000",
          align: "end",
          rotation: 0,
          formatter: function (value, context) {
            return parseFloat(value).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        };
      } else if (item[0] == auxAnoAnterior) {
        datalabels = {
          anchor: "start",
          display: true,
          color: cor,
          align: "start",
          rotation: 0,
          formatter: function (value, context) {
            return parseFloat(value).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        };
      } else {
        datalabels = {
          formatter: function (value, context) {
            return "";
          },
        };
      }
      dataSets.push({
        label: item[0],
        data: dadosGrupo,
        backgroundColor: cor,
        datalabels: datalabels,
      });
    });
    await Promise.all(promise);
    const data = {
      labels: label,
      datasets: dataSets,
    };
    dadosTabelaAux = agruparPor(dadosTabelaAux, "mes");
    dadosTabelaAux = Object.entries(dadosTabelaAux);
    preencherDadosTabelaMes(dadosTabelaAux);
    setDadosGraficoAgrupado2(data);
    setFiltrosAtivosLojasTexto(
      filtrosAtivosLojasTexto.split("- Loja")[0] + " - Loja " + loja
    );

    setNivelAtivoDoGrafico(2);
  }

  function preencherDadosVendasPorLoja() {
    preencherDadosVendasPorLojaGrupo();
    const dadosUltimoPeriodoTemp = [...dadosUltimoPeriodo];
    let dataVendas = dadosGerais;
    let auxLojasSelecionadas = [];

    dataVendas.map((a) => {
      if (auxLojasSelecionadas.indexOf(converterLoja(a.codLoja)) == -1) {
        auxLojasSelecionadas.push(converterLoja(a.codLoja));
      }
    });
    if (filtrosLojasSelecionadas.length > 0) {
      dataVendas = dataVendas.filter((a) => {
        if (filtrosLojasSelecionadas.indexOf(converterLoja(a.codLoja)) >= 0) {
          return true;
        } else {
          return false;
        }
      });
    }
    let grupoDeAnos = agruparPor(dataVendas, "ano");
    let grupoDeAnosArray = Object.entries(grupoDeAnos);
    let separadoPorGrupo = [];
    grupoDeAnosArray.map((item) => {
      let grupoDeLoja = agruparPor(item[1], "codGrp1");
      separadoPorGrupo.push(grupoDeLoja);
    });
    let resumoSeparadoPorGrupo = [];
    separadoPorGrupo.map((item) => {
      let item2 = Object.entries(item);
      item2.map((item3) => {
        let total = 0;
        let totalPedidos = 0;
        let ano;
        let codGrupo;
        let nomeGrupo;
        let totalCusto = 0;
        let totalLucro = 0;
        let porcentagemLucro = 0;
        item3[1].map((item4, index) => {
          if (index == 0) {
            ano = item4.ano;
            nomeGrupo = item4.nomeGrp1;
            codGrupo = item4.codGrp1;
          }
          totalPedidos += parseInt(item4.totalPedidos);
          total += parseFloat(item4.vlrTotal);
          totalCusto += parseFloat(item4.vlrCusto);
          totalLucro += parseFloat(item4.vlrLucroBruto);
          porcentagemLucro += parseFloat(item4.vlrLucroBrutoPorcentagem);
        });
        porcentagemLucro = porcentagemLucro / item3[1].length;
        let resumoLojaAno = {
          ano: ano,
          codGrupo,
          nomeGrupo,
          total: total,
          totalPedidos: totalPedidos,
          totalCusto,
          totalLucro,
          porcentagemLucro,
        };
        resumoSeparadoPorGrupo.push(resumoLojaAno);
      });
    });
    var agrupado = agruparPor(resumoSeparadoPorGrupo, "ano");
    grupoDeAnosArray = Object.entries(agrupado);
    preencherDadosGraficoAgrupado(
      grupoDeAnosArray,
      tipoPeriodo,
      auxAnoAtual,
      auxAnoAnterior,
      dadosUltimoPeriodoTemp
    );
  }

  function preencherDadosVendasPorLojaGrupo() {
    let dataVendas = dadosGeraisGrupo;
    let auxLojasSelecionadas = [];
    if (!dataVendas || dataVendas.length == 0) return;
    dataVendas.map((a) => {
      if (auxLojasSelecionadas.indexOf(converterLoja(a.codLoja)) == -1) {
        auxLojasSelecionadas.push(converterLoja(a.codLoja));
      }
    });
    if (filtrosLojasSelecionadas.length > 0) {
      dataVendas = dataVendas.filter((a) => {
        if (filtrosLojasSelecionadas.indexOf(converterLoja(a.codLoja)) >= 0) {
          return true;
        } else {
          return false;
        }
      });
    }
    let grupoDeAnos = agruparPor(dataVendas, "ano");
    let grupoDeAnosArray = Object.entries(grupoDeAnos);
    let separadoPorLoja = [];
    grupoDeAnosArray.map((item) => {
      let grupoDeLoja = agruparPor(item[1], "codLoja");
      separadoPorLoja.push(grupoDeLoja);
    });
    let resumoSeparadoPorLoja = [];
    separadoPorLoja.map((item) => {
      let item2 = Object.entries(item);
      item2.map((item3) => {
        let total = 0;
        let totalPedidos = 0;
        let ano;
        let codGrupo;
        let nomeGrupo;
        let totalCusto = 0;
        let totalLucro = 0;
        let porcentagemLucro = 0;
        let codLoja = 0;
        item3[1].map((item4, index) => {
          if (index == 0) {
            ano = item4.ano;
            nomeGrupo = item4.nomeGrp1;
            codGrupo = item4.codGrp1;
          }
          totalPedidos += parseInt(item4.totalPedidos);
          total += parseFloat(item4.vlrTotal);
          totalCusto += parseFloat(item4.vlrCusto);
          totalLucro += parseFloat(item4.vlrLucroBruto);
          porcentagemLucro += parseFloat(item4.vlrLucroBrutoPorcentagem);
          codLoja = item4.codLoja;
        });
        porcentagemLucro = porcentagemLucro / item3[1].length;
        let resumoLojaAno = {
          ano: ano,
          codGrupo,
          nomeGrupo,
          total: total,
          totalPedidos: totalPedidos,
          totalCusto,
          totalLucro,
          porcentagemLucro,
          codLoja,
        };
        resumoSeparadoPorLoja.push(resumoLojaAno);
      });
    });
    var agrupado = agruparPor(resumoSeparadoPorLoja, "ano");
    grupoDeAnosArray = Object.entries(agrupado);
    preencherDadosGraficoAgrupadoGrupo(
      grupoDeAnosArray,
      tipoPeriodo,
      auxAnoAnterior,
      auxAnoAtual
    );
  }

  function iniciarFiltroPorPeriodo() {
    setTipoPeriodo("input");
    setAuxTipoPeriodo("input");
    setPeriodoAno(false);
    setFiltrosAnosSelecionados([]);
    setPeriodoInputInicio(periodoInputInicioAux);
    setPeriodoInputFim(periodoInputFimAux);
  }

  const fVoltar = () => {
    if (nivelAtivoDoGrafico === 1) {
      setGrupoAtivo("");
      setFiltrosAtivosLojasTexto("");
    }

    if (nivelAtivoDoGrafico === 2) {
      let novoNivel = nivelAtivoDoGrafico - 1;
      setNivelAtivoDoGrafico(novoNivel);

      setDadosParaTabela(dadosParaTabelaLoja);
      let filtrosAtivos = filtrosAtivosLojasTexto.split("- Loja")[0];
      setFiltrosAtivosLojasTexto(filtrosAtivos);
      setLojaTable(true);
      setTipoPeriodo("input");
    } else if (nivelAtivoDoGrafico === 1) {
      let novoNivel = nivelAtivoDoGrafico - 1;
      setNivelAtivoDoGrafico(novoNivel);

      setLojaTable(false);
      setDadosParaTabela(auxDadosParaTabela);
    }
  };

  function filtrarPorLoja(loja) {
    const lojasSelecionadas = loja.map((item) => item.label);
    LoadingTemp();
    setAuxTipoPeriodo("loja");

    setFiltradoPorLoja(true);
    setFiltrosLojasSelecionadas(lojasSelecionadas);
    var lojasDisponiveisAux = [];
    lojasDisponiveis.map((item) => {
      lojasDisponiveisAux.push(item);
    });
    if (lojasSelecionadas.length === 0) {
      preencherInputPeriodo();
    } else {
      setAnosDisponiveis(fAnosPorLoja(lojasSelecionadas));
      setLojasDisponiveis(lojasDisponiveisAux);
    }
    setLojaTable(false);
    setTipoPeriodo("input");
  }

  function iniciarFiltroHoje() {
    var dataHoje = new Date();
    var [, hoje] = converterDataFormatoPadrao(dataHoje);

    setPeriodoInputInicio(hoje);
    setPeriodoInputFim(hoje);

    setPeriodoInputInicioAux(hoje);
    setPeriodoInputFimAux(hoje);
  }

  const getElementAtEventY = (element) => {
    if (!element.length) return;
    const { _index: index, _yScale: eixoY } = element[0];
    if (nivelAtivoDoGrafico == 0) {
      var nomeGrupo = eixoY.ticks[index];
      setGrupoAtivo(nomeGrupo);
      setLojaTable(true);
    } else if (nivelAtivoDoGrafico == 1) {
      var nomeLoja = eixoY.ticks[index];
      preencherDadosGraficoAgrupadoGrupoMes(nomeLoja);
      setLojaTable(false);
      setTipoPeriodo("mes");
    }
  };

  const filtrarBases = (value) => {
    const basesSelecionadasTemp = value;

    setBasesSelecionadas(basesSelecionadasTemp);
    setBase(basesSelecionadasTemp);
  };
  return (
    <>
      {PermissionsPage("vendGrupo") && (
        <>
          <Box ml={2}>
            <Title title="Vendas Por Grupo" />
          </Box>

          <Stack gap={2} direction={"row"} mx={2}>
            <Box component={Paper} variant="outlined" px={1} pb={1}>
              <FiltroPeriodo
                periodoInputInicioAux={periodoInputInicioAux}
                periodoInputFimAux={periodoInputFimAux}
                setPeriodoInputInicioAux={setPeriodoInputInicioAux}
                setPeriodoInputFimAux={setPeriodoInputFimAux}
              />
              <Stack gap={1}>
                <ButtonFilter
                  type="button"
                  onClick={() => iniciarFiltroPorPeriodo()}
                  disabled={isLoading}
                >
                  Filtrar
                </ButtonFilter>
                <ButtonToday
                  type="button"
                  onClick={() => iniciarFiltroHoje()}
                  disabled={isLoading}
                >
                  Hoje
                </ButtonToday>
              </Stack>
            </Box>

            <Box width={"100%"}>
              <Box pb={1}>
                <MultiSelectFilterBases
                  basesDisponiveis={basesDisponiveis}
                  basesSelecionadas={basesSelecionadas}
                  onChange={filtrarBases}
                  disabled={isLoading}
                />
                <Typography variant="caption" component={"span"}>
                  *Atenção: Quando nenhuma base estiver selecionada, todas as
                  bases serão retornadas.*
                </Typography>
              </Box>
              <Box>
                <Typography
                  textAlign={"initial"}
                  fontWeight={"bold"}
                  component={"span"}
                >
                  Lojas
                </Typography>
                <Select
                  options={lojasDisponiveis.map((item) => ({
                    label: item,
                    value: item.toString().split(" ")[1],
                  }))}
                  isMulti
                  onChange={filtrarPorLoja}
                  placeholder="Selecione uma loja"
                  styles={colourStyles}
                  isDisabled={isLoading}
                />
                <Typography variant="caption" component={"span"}>
                  *Atenção: Quando nenhuma loja estiver selecionada, todas as
                  lojas serão retornadas.*
                </Typography>
              </Box>
            </Box>
          </Stack>

          {isLoading ? (
            <Box
              width={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"90vh"}
            >
              <LoadingTable isLoading={isLoading} />
            </Box>
          ) : (
            <>
              <>
                {dadosDisponiveis && (
                  <Box mx={2} component={Paper} variant="outlined" p={2} m={2}>
                    {nivelAtivoDoGrafico === 0 && (
                      <>
                        <HorizontalBar
                          data={dadosGraficoAgrupado}
                          height={500}
                          options={optionsChartBarVendasY}
                          getElementAtEvent={getElementAtEventY}
                        />
                      </>
                    )}
                    {nivelAtivoDoGrafico === 1 && (
                      <HorizontalBar
                        data={dadosGraficoAgrupado1}
                        height={500}
                        options={optionsChartBarVendas}
                        getElementAtEvent={getElementAtEventY}
                      />
                    )}
                    {nivelAtivoDoGrafico === 2 && (
                      <HorizontalBar
                        data={dadosGraficoAgrupado2}
                        options={optionsChartBarVendas}
                        getElementAtEvent={getElementAtEventY}
                      />
                    )}
                    <ButtonVoltar fVoltar={fVoltar} />
                  </Box>
                )}
              </>

              {dadosDisponiveis && exibeTabela && (
                <Tabs
                  defaultActiveKey="por_grupo"
                  id="uncontrolled-tab-example"
                  className=""
                >
                  <Tab eventKey="por_grupo" title="Vendas por fornecedor">
                    <Box>
                      <TabelaNext
                        dadosParaTabela={dadosParaTabela}
                        colunas={vendasGrupoTabelaPorGrupo(
                          tipoPeriodo,
                          anosDisponiveis,
                          filtrosAnosSelecionados,
                          lojaTable,
                          filtrosLojasSelecionadas,
                          nivelAtivoDoGrafico
                        )}
                      />
                    </Box>
                  </Tab>
                  <Tab
                    eventKey="por_loja"
                    title="Vendas por loja"
                    disabled={nivelAtivoDoGrafico !== 0}
                  >
                    {!!lojasPresentesTabelaPorLoja.length && (
                      <Box
                        mx={2}
                        variant="outlined"
                        m={2}
                        sx={{
                          "& .react-bootstrap-table": {
                            overflowX: "scroll",
                          },
                        }}
                      >
                        <TabelaNext
                          dadosParaTabela={dadosTabelaPorLoja}
                          colunas={colunasTabelaPorLoja(
                            lojasPresentesTabelaPorLoja,
                            dadosTabelaPorLoja
                          )}
                        />
                      </Box>
                    )}
                  </Tab>
                </Tabs>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}

export default VendasPorGrupo;
